import { render, staticRenderFns } from "./gamePage.vue?vue&type=template&id=f99f68aa&scoped=true"
import script from "./gamePage.vue?vue&type=script&lang=js"
export * from "./gamePage.vue?vue&type=script&lang=js"
import style0 from "./gamePage.vue?vue&type=style&index=0&id=f99f68aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99f68aa",
  null
  
)

export default component.exports